import { Card } from 'primereact/card';
import React from 'react';
import { withTranslation } from 'react-i18next';
import publicIp from 'react-public-ip';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import { CustomDialog } from '../components/CustomDialog';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';
import SimpleReactValidator from '../components/validator';
import AuthService from '../services/AuthService';
import InvoiceService from '../services/InvoiceService';

class InvoiceFlsActionDialog extends BaseContainer {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.invoiceService = new InvoiceService();
        this.state = {
            userIp: '',
            showRejectionDialog: props.showRejectionDialog,
            actionForm: {
                rejectionCode: undefined,
                rejectionText: '',
            },
            rejectionCodeOptions: [],
        };
        this.rejectionValidator = new SimpleReactValidator({}, this.translate);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'invoice-fls-action-dialog';
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.showRejectionDialog && this.props.showRejectionDialog) {
            this.setState({
                showRejectionDialog: this.props.showRejectionDialog,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const {t} = this.props;
        this.enumService
            .getEnumList('EcFleetStatementRejecetionCode', t)
            .then((rejectionCodeOptions) => {
                this.setState(
                    {
                        rejectionCodeOptions,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('fleetStatement.rejectionCodeListError'));
                this.unblockUi();
            });
        publicIp.v4().then((response) => {
            this.setState({
                userIp: response,
            });
        });
    }

    fleetStatementAction(actionType) {
        const {t, invoiceNumber} = this.props;
        const {userIp, actionForm} = this.state;
        if (actionType === 'ACCEPT' || (actionType === 'REJECT' && this.rejectionValidator.allValid())) {
            this.blockUi();
            this.invoiceService
                .fleetStatementActionPublic(
                    undefined,
                    invoiceNumber.replace('PPS', ''),
                    userIp,
                    actionType,
                    actionType !== 'ACCEPT' ? actionForm.rejectionCode : undefined,
                    actionType !== 'ACCEPT' ? actionForm.rejectionText : undefined
                )
                .then((res) => {
                    if (actionType === 'ACCEPT') {
                        this.showSuccessMessage(t('fleetStatement.acceptSuccess'));
                    } else if (actionType === 'REJECT') {
                        this.showSuccessMessage(t('fleetStatement.rejectionSuccess'));
                    }
                    this.setState({
                        showFlsDialog: false,
                        showRejectionDialog: false,
                        password: '',
                        actionForm: {
                            rejectionCode: undefined,
                            rejectionText: '',
                        },
                    });
                    this.props.hideDialog();
                    this.unblockUi();
                })
                .catch((err) => {
                    if (actionType === 'ACCEPT') {
                        this.showErrorMessage(err.message);
                    } else if (actionType === 'REJECT') {
                        // this.showErrorMessage(t('fleetStatement.rejectionError'));
                        this.showErrorMessage(err.message);
                    }
                    this.unblockUi();
                });
        } else {
            this.rejectionValidator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                {this.state.showRejectionDialog ? (
                    <CustomDialog
                        name='fleet-statement-rejection-dialog'
                        className='fleet-statement-rejection-dialog'
                        visible={this.state.showRejectionDialog}
                        viewMode={'NEW'}
                        onHide={() => {
                            this.setState({showRejectionDialog: false});
                            this.props.hideDialog();
                        }}
                        modal
                        header={t('fleetStatement.rejectionDialogHeader')}
                    >
                        <Card
                            footer={() => (
                                <div className='footer-dialog-button-container'>
                                    <ActionButton
                                        label={t('fleetStatement.rejectionSend')}
                                        variant='next-button'
                                        handleClick={(e) => {
                                            e.preventDefault();
                                            this.fleetStatementAction('REJECT');
                                        }}
                                    />
                                </div>
                            )}
                        >
                            <InputDropdownComponent
                                id='rejectionCode'
                                name='rejectionCode'
                                label={t('fleetStatement.rejectionCode')}
                                colClass='col-12'
                                value={this.state.actionForm.rejectionCode}
                                viewMode='NEW'
                                validator={this.rejectionValidator}
                                validators='required'
                                options={this.state.rejectionCodeOptions}
                                onChange={this.handleChange}
                                optionLabel='label'
                                required
                                renderRequired
                                stateField='actionForm'
                                enumMode
                                enumName='EcFleetStatementRejecetionCode'
                                optionValue='enumValue'
                                dataKey='enumValue'
                            />
                            <InputTextareaComponent
                                id='rejectionText'
                                name='rejectionText'
                                label={t('fleetStatement.rejectionText')}
                                colClass='col-12'
                                value={this.state.actionForm.rejectionText}
                                validator={this.rejectionValidator}
                                validators='required|min:30|max:500'
                                onChange={this.handleChange}
                                viewMode='NEW'
                                autoResize
                                showLabel={false}
                                stateField='actionForm'
                            ></InputTextareaComponent>
                        </Card>
                    </CustomDialog>
                ) : null}
            </React.Fragment>
        );
    }
}

InvoiceFlsActionDialog.propTypes = {};

export default withTranslation()(InvoiceFlsActionDialog);
